import { Table, Tag, Text } from '@loadsmart/loadsmart-ui'

import { hasValidDeadline, type RfpSummary } from '../domain/RfpSummary'
import {
  formatContractDate,
  formatContractDeadline,
  getBidState,
  getBidStatusTagType as getBidStatusTagVariant,
} from '../presenters/rfpHistoryPresenter'
import { StyledDeadlineDate } from './RfpSummaryListItem.styles'
import { RfpSummaryListItemAction } from './RfpSummaryListItemAction'

export type RfpListItemProps = {
  rfpSummary: RfpSummary
}

export function RfpListItem({ rfpSummary }: RfpListItemProps) {
  const tagVariant = getBidStatusTagVariant(rfpSummary.bidState)
  const contractDate = formatContractDate(rfpSummary.rfpContractStart, rfpSummary.rfpContractEnd)
  const deadlineDate = formatContractDeadline(rfpSummary.rfpRequestDeadline)
  const isDeadlineValid = hasValidDeadline(rfpSummary.rfpRequestDeadline)

  return (
    <Table.Row key={rfpSummary.rfpId}>
      <Table.Cell>{rfpSummary.rfpName}</Table.Cell>
      <Table.Cell>{rfpSummary.shipperName}</Table.Cell>
      <Table.Cell>
        <Tag variant={tagVariant}>{getBidState(rfpSummary.bidState)}</Tag>
      </Table.Cell>
      <Table.Cell>{contractDate}</Table.Cell>
      <Table.Cell>
        <Text variant="body-bold">{rfpSummary.lanesCount}</Text>
      </Table.Cell>
      <Table.Cell>
        <Text variant="body-bold"> {rfpSummary.laneProposalsCount}</Text>
      </Table.Cell>
      <Table.Cell>
        <Text variant="body-bold">{rfpSummary.awardedLaneProposalsCount}</Text>
      </Table.Cell>
      <Table.Cell>
        <StyledDeadlineDate $hasValidDeadline={isDeadlineValid}>{deadlineDate}</StyledDeadlineDate>
      </Table.Cell>
      <Table.Cell>
        <RfpSummaryListItemAction rfpSummary={rfpSummary} />
      </Table.Cell>
    </Table.Row>
  )
}
